import React from 'react';
import im from '../../image/000-404.png';

const NotFound = () => {
    return (
        <div>
            <p><img src={im} alt="" srcset="" /></p>
        </div>
    );
};

export default NotFound;